import { TlzEnvironment, _getEventDatesUrl } from './constants';

export const getEventSessionsByDate = async ({
    env,
    eventId,
    date,
    tzIdentifier,
}: {
    env: TlzEnvironment;
    eventId: string;
    date: string;
    tzIdentifier: string;
}) => {
    const response = await fetch(
        _getEventDatesUrl({
            env,
            eventId,
            date,
            tzIdentifier,
        }),
        {
            method: 'GET',
            credentials: 'include',
        },
    );

    let body = null;

    try {
        body = await response.json();
    } catch (error) {
        throw new Error(`Checkout Fairy returned an error: ${error.message}`);
    }

    if (body.error) {
        throw new Error(
            `Checkout Fairy returned a body describing an error: ${body.error} (full body: ${body})`,
        );
    }

    return body;
};
